import React from "react";

const styles = {
  pageContainer: {
    display: "flex",
    width: "100vw",
    height: "100vh",
    alignItems: "center",
    justifyContent: "center",
    background: "linear-gradient(135deg, #000000 0%, #1a1a2e 50%, #16213e 100%)",
  },
  
  container: {
    width: "100%",
    maxWidth: "420px",
    backgroundColor: "rgba(255, 255, 255, 0.05)",
    border: "1px solid rgba(65, 105, 225, 0.2)",
    boxShadow: "0 0 30px rgba(65, 105, 225, 0.3)",
    borderRadius: "16px",
    overflow: "hidden",
  },

  content: {
    padding: "32px",
    textAlign: "center" as const,
  },

  title: {
    fontSize: "1.875rem",
    fontWeight: "bold",
    marginBottom: "1rem",
    color: "#ffffff",
  },

  message: {
    color: "#D1D5DB",
    fontSize: "16px",
    lineHeight: "1.6",
    marginBottom: "24px",
  },

  link: {
    color: "#4F46E5",
    textDecoration: "underline",
    fontWeight: "500",
  },
};

const Unauthorized: React.FC = () => {
  return (
    <div style={styles.pageContainer}>
      <div style={styles.container}>
        <div style={styles.content}>
          <h1 style={styles.title}>Unauthorized</h1>
          <p style={styles.message}>
            You are not authorized to view this page. Please{" "}
            <a 
              href="https://dineplatform.com/contact" 
              style={styles.link}
              target="_blank"
              rel="noopener noreferrer"
            >
              contact us
            </a>{" "}
            to get started.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;